import { createSlice } from "@reduxjs/toolkit";

const initialState = false;

export const loyaltyModalSlice = createSlice({
  name: "loyaltyModal",
  initialState,
  reducers: {
    openLoyaltyProgramModalAction: () => {
      return true;
    },
    closeLoyaltyProgramModalAction: () => {
      return false;
    },
  },
});

// Action creators
export const { openLoyaltyProgramModalAction, closeLoyaltyProgramModalAction } =
  loyaltyModalSlice.actions;

// Thunks
export const openLoyaltyProgramModal = () => (dispatch) => {
  dispatch(openLoyaltyProgramModalAction());
};

export const closeLoyaltyProgramModal = () => (dispatch) => {
  dispatch(closeLoyaltyProgramModalAction());
};

export default loyaltyModalSlice.reducer;
